import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票信息")
], -1)
const _hoisted_2 = { class: "form-dialog__content" }

import { ref } from 'vue';
import { BaseForm, BaseFormItem, BaseInput, BaseSelect } from 'xrk-components';
import { listSelectEnterprise } from '@V/invoice/src/data-source/apis';
import { IndustryDetailData } from '@V/invoice/src/data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-offline-dialog-info',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {



const formRef = ref(null);
const formData = _useModel<IndustryDetailData>(__props, "modelValue");
const formRules = {
  industryId: [{ required: true, message: '请选择', trigger: 'change' }]
};

/**
 * @description: 获取当前企业关联的工业列表，并通过该数据完善开票信息、邮寄地址
 *               注意：工业角色该接口没有数据
 *               在禁用状态下或者工业打开时，将直接显示企业名称而不进行搜索
 */
const industryIdRemote = industryName => {
  return listSelectEnterprise({
    industryName
  });
};

const onIndustryIdChange = (v, [option]) => {
  Object.assign(formData.value, option);
};

__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    scrollToError: "",
    model: formData.value,
    rules: formRules,
    disabled: _ctx.disabled
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "企业名称",
          prop: "industryId"
        }, {
          default: _withCtx(() => [
            (!_ctx.disabled)
              ? (_openBlock(), _createBlock(_unref(BaseSelect), {
                  key: 0,
                  class: "form-dialog__w280",
                  placeholder: "请选择",
                  labelKey: "industryName",
                  valueKey: "industryId",
                  init: "",
                  remoteMethod: industryIdRemote,
                  modelValue: formData.value.industryId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.industryId) = $event)),
                  onChange: onIndustryIdChange
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(_unref(BaseInput), {
                  key: 1,
                  class: "form-dialog__w280",
                  type: "text",
                  modelValue: formData.value.industryName
                }, null, 8, ["modelValue"]))
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "纳税识别号",
          prop: "invoiceIdentifierNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoiceIdentifierNo
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "联系电话",
          prop: "invoicePhone"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "tel",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoicePhone
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "开户银行",
          prop: "invoiceOpenBank"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoiceOpenBank
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "银行账号",
          prop: "invoiceBankNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoiceBankNo
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "企业地址",
          prop: "invoiceEnterpriseAddress"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoiceEnterpriseAddress
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model", "disabled"]))
}
}

})